import * as React from 'react';

export const chevronDown = (): React.ReactElement => (
  <path d="M1.5 5L8 11l6.5-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
);

export default chevronDown;
